<div class="flex items-center justify-center" *ngIf="user">
    <span class="font-medium mr-1 capitalize hidden sm:block">{{ user?.name }}</span>
    <!-- Button -->
    <button mat-icon-button [matMenuTriggerFor]="userActions">
        <span class="relative flex items-center justify-center">
            <mat-icon class="icon-size-7" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        </span>
    </button>

    <mat-menu [xPosition]="'before'" #userActions="matMenu">
        <button mat-menu-item>
            <span class="flex flex-col leading-none">
                <span>Acessando como</span>
                <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
            </span>
        </button>
        <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item (click)="editUser()">
            <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
            <span>Perfil</span>
        </button>
        <!--
        <button *ngIf="isHome && user.function?.is_admin" mat-menu-item [routerLink]="['/home/funcoes']">
            <mat-icon [svgIcon]="'heroicons_outline:key'"></mat-icon>
            <span>Funções</span>
        </button>
        <button *ngIf="isHome && user.function?.is_admin" mat-menu-item [routerLink]="['/home/usuarios/user']">
            <mat-icon [svgIcon]="'heroicons_outline:users'"></mat-icon>
            <span>Usuários</span>
        </button>
        <button *ngIf="isHome && user.function?.is_admin" mat-menu-item [routerLink]="['/home/banners']">
            <mat-icon [svgIcon]="'heroicons_outline:photo'"></mat-icon>
            <span>Banner</span>
        </button>
        <button *ngIf="isHome && user.function?.is_admin" mat-menu-item [routerLink]="['/home/holidays']">
            <mat-icon [svgIcon]="'heroicons_outline:globe-americas'"></mat-icon>
            <span>Feriados</span>
        </button>

        <button mat-menu-item [routerLink]="['/change-password']">
            <mat-icon [svgIcon]="'heroicons_outline:shield-check'"></mat-icon>
            <span>Alterar senha</span>
        </button> -->
        <!-- <button mat-menu-item (click)="toggleSchema()">
            <mat-icon [svgIcon]="'heroicons_outline:adjustments-horizontal'"></mat-icon>
            <span>Alternar Esquema ({{ schema === 'light' ? 'Claro' : schema === 'dark' ? 'Escuro' : 'Automático' }})</span>
        </button> -->
        <!-- <div mat-menu-item class="uppercase font-semibold flex text-gray-700 dark:text-secondary-500 ml-4">
            <button mat-icon-button [matTooltip]="isDark ? 'Claro' : 'Escuro'" (click)="setTheme(isDark ? 'light' : 'dark')">
                <mat-icon [svgIcon]="isDark ? 'heroicons_outline:sun' : 'heroicons_outline:moon'"></mat-icon>
            </button>
            <button mat-icon-button [matTooltip]="isAuto ? 'Auto Ligado' : 'Auto Desligado'" (click)="setThemeAuto()">
                <mat-icon [svgIcon]="isAuto ? 'heroicons_solid:bolt' : 'heroicons_outline:bolt'"></mat-icon>
            </button>
        </div> -->
        <button mat-menu-item (click)="signOut()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
            <span>Sair</span>
        </button>
    </mat-menu>
</div>
